module.exports = __webpack_public_path__ + "static/img/item1.b18419e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/item1.png
// module id = BeJI
// module chunks = 0